import React, { useContext } from "react";
import microLessonThumbnail from "../../assets/icons/ld-microlesson-thumbnail.png";
import { PagesManagementContext } from "../../routes/builderContexts";
import "./AggregationPageLister.css"; // New styles
import StandardPageListerPanel from "./StandardPageListerPanel";
import ILessonPage from "../../models/ILessonPage";
import WarningIcon from "../WarningIcon";

interface IAggregationPageListerProps {
  expanded: boolean;
  aggregation: ILessonPage;
  toggleExpand: () => void;
  outdated?: boolean;
}

const AggregationPageLister: React.FC<IAggregationPageListerProps> = ({
  aggregation,
  expanded,
  toggleExpand,
  outdated,
}) => {
  const {
    switchCurrentlyDisplayedPage,
    showOutdatedMicroLessonModal,
    pagePullout,
    currentAggregationOrder,
    currentlyDisplayedPageIndex,
    lessonPagesNumbering,
  } = useContext(PagesManagementContext);

  const { order, name, pageManifest } = aggregation;
  const Pages = pageManifest?.Pages ?? [];
  const containerStyle = expanded ? "aggregation-box expanded" : "aggregation-box";
  const isSelected = currentAggregationOrder === aggregation.order ? "selected-aggregation" : "";

  return (
    <>
      <div className={[containerStyle, isSelected].join(" ")}>
        <div className="aggregation-header">
          <img src={microLessonThumbnail} alt="microlesson" className="microlesson-thumbnail" />
          <p> {order + 1}. </p>
          <div className="aggregation-title" title={name}>
            {name}
          </div>
        </div>
        <button
          className="expand-button-container"
          onClick={(e) => {
            e.stopPropagation();
            toggleExpand();
          }}
        >
          <div className="expand-button">{expanded ? "▲" : "▼"}</div>
        </button>
        <WarningIcon
          visible={outdated ?? false}
          tooltipId="New Version Available"
          onClick={showOutdatedMicroLessonModal}
        />
      </div>

      <div className="aggregation-box-content">
        {expanded &&
          Pages.map((nestedPage, currentPageIndex) => {
            let flagDirection = "";
            if (currentPageIndex <= 3) {
              flagDirection = "start";
            }

            if (currentPageIndex > Pages.length - 4) {
              flagDirection = "end";
            }

            const isPageSelected =
              currentAggregationOrder === aggregation.order && currentPageIndex === currentlyDisplayedPageIndex;

            const aggregationArray = lessonPagesNumbering[aggregation.order];
            const currentPageNumber = Array.isArray(aggregationArray) ? aggregationArray[currentPageIndex] : null;

            return (
              <StandardPageListerPanel
                key={nestedPage.name + currentPageIndex}
                pagePullout={pagePullout}
                switchPage={(index) => {
                  switchCurrentlyDisplayedPage(index, { aggregationOrder: aggregation.order });
                }}
                index={currentPageIndex}
                flagDirection={flagDirection}
                name={nestedPage.name}
                modes={nestedPage.lessonModeIds}
                selected={isPageSelected}
                displayedPageNumber={currentPageNumber}
                microLessonOrder={aggregation.order}
              />
            );
          })}
      </div>
    </>
  );
};

export default AggregationPageLister;
